var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _line, _line2, _line3, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlexReport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 45,
    viewBox: "0 0 36 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2661 28.6364L11.0831 28.6364C10.2743 28.6364 9.49852 28.3151 8.92655 27.7431C8.35459 27.1711 8.03326 26.3954 8.03326 25.5865L8.03326 5.25697C8.03326 4.44809 8.35458 3.67234 8.92655 3.10037C9.49851 2.52841 10.2743 2.20708 11.0831 2.20708L25.316 2.20708C26.1249 2.20708 26.9006 2.5284 27.4726 3.10037C28.0445 3.67234 28.3659 4.44809 28.3659 5.25697L28.3659 22.5386L23.2827 22.5386C23.0131 22.5386 22.7545 22.6457 22.5638 22.8364C22.3732 23.0271 22.2661 23.2856 22.2661 23.5553L22.2661 28.6384L22.2661 28.6364ZM30.3991 23.4963L30.3991 5.25697C30.3991 3.90883 29.8636 2.61591 28.9103 1.66264C27.957 0.709362 26.6641 0.173817 25.316 0.173817L11.0831 0.173819C9.73501 0.173819 8.44209 0.709364 7.48882 1.66264C6.53554 2.61592 6 3.90884 6 5.25697L6 25.5885C6.00027 26.9365 6.53593 28.2291 7.48918 29.1822C8.44242 30.1353 9.73519 30.6707 11.0831 30.6707L23.2258 30.6707C23.3689 30.6799 23.5123 30.6581 23.6462 30.6066C23.7801 30.5552 23.9013 30.4755 24.0015 30.3728L30.1013 24.273C30.3249 24.0494 30.4164 23.7677 30.3981 23.4973L30.3991 23.4963ZM24.2993 24.5699L26.9273 24.5699L24.3004 27.1989L24.2993 24.5699Z",
    fill: "#333852"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0852 26.6063C10.8156 26.6063 10.557 26.4992 10.3664 26.3086C10.1757 26.1179 10.0686 25.8593 10.0686 25.5897C10.0686 25.3201 10.1757 25.0615 10.3664 24.8708C10.557 24.6802 10.8156 24.5731 11.0852 24.5731H20.2349L20.2359 25.0814C20.2359 25.0814 20.2359 25.3201 20.2359 25.5897C20.2359 25.8593 20.2359 26.098 20.2359 26.098L20.2349 26.6063H11.0842H11.0852ZM11.0852 22.5398C10.8156 22.5398 10.557 22.4327 10.3664 22.2421C10.1757 22.0514 10.0686 21.7928 10.0686 21.5232C10.0686 21.2536 10.1757 20.995 10.3664 20.8043C10.557 20.6137 10.8156 20.5066 11.0852 20.5066H20.2349L20.2359 21.0149V21.5232V22.0315L20.2349 22.5398H11.0842H11.0852Z",
    fill: "#856DCB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0686 11.3567L10.0686 17.9658L14.1351 17.9658L14.1351 8.81514L10.0686 11.3567Z",
    fill: "#333852"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2349 11.3567L20.2349 17.9658L16.1683 17.9658L16.1683 8.81514L20.2349 11.3567Z",
    fill: "#333852"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2681 11.3567L22.2681 17.9658L26.3346 17.9658L26.3346 8.81514L22.2681 11.3567Z",
    fill: "#333852"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0852,
    cy: 8.30722,
    r: 0.76663,
    stroke: "#333852",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1519,
    cy: 5.25717,
    r: 0.76663,
    stroke: "#333852",
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2515,
    cy: 8.30722,
    r: 0.76663,
    stroke: "#333852",
    strokeWidth: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.3181,
    cy: 5.25717,
    r: 0.76663,
    stroke: "#333852",
    strokeWidth: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.667,
    y1: 7.99631,
    x2: 14.5664,
    y2: 5.74999,
    stroke: "#333852",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.7707,
    y1: 7.99709,
    x2: 24.7203,
    y2: 5.68783,
    stroke: "#333852",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20.6336,
    y1: 7.97188,
    x2: 15.8809,
    y2: 5.6546,
    stroke: "#333852",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 44.1738C27.9411 44.1738 36 43.7261 36 43.1738C36 42.6215 27.9411 42.1738 18 42.1738C8.05887 42.1738 0 42.6215 0 43.1738C0 43.7261 8.05887 44.1738 18 44.1738Z",
    fill: "#333852",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlexReport);
export default __webpack_public_path__ + "static/media/icon-flex-report.2c269cc64bc00001202f9531ffc0e881.svg";
export { ForwardRef as ReactComponent };